import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Field, FieldArray, reset } from 'redux-form'
import {
  Grid, Row, Col, Panel, ButtonToolbar, Button, DropdownButton, MenuItem,
  FieldGroup, Input
} from 'react-bootstrap';
import { Link } from 'react-router';
import { Translate, Localize, I18n } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';

import ContentWrapper from '../Layout/ContentWrapper';
import SetWeightModal from '../../containers/Dispatch/setWeightModal';
import SerialNumModal from '../../components/Dispatch/serialNumModal';
import EmailContentModal from  './components/EmailContentModal';
import BatchModal from  './components/BatchModal';
import NewBatchModal from  './components/NewBatchModal';
import Selection from '../Common/selection'
import { UI_HEIGHT } from '../Common/constants';
import { InputField, DisabledInputField, ControlledInputField } from '../Common/inputField';
import ConfirmActionModal from '../Common/confirmActionModal';
import Spinner from '../Widgets/spinner';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import {
  ROOT_URL, ROOT_API_URL, isOCM, isSKH, isGGI, isSUN, isSV, isLAP, isAPD, isOLG, isABCFF,
  isVAK, isCCW, isSH, isAP,
} from '../../actions/root_url';
import { getLocalStorageData } from '../../../jsx/reducers/headerRedux';
import { debounce } from 'lodash';

const isMyumyu = (ROOT_API_URL === 'https://mmstage-scm.truckxi.com/api/' || ROOT_API_URL === 'https://myumyu-scm.truckxi.com/api/')
const isAFG = ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || ROOT_URL === 'https://afg-scm.truckxi.com/api/';
const isWecom = ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/' || ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/';
const isAFM =
  ROOT_API_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_API_URL === "https://afmstage-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afmstage-scm.truckxi.com/api/";
const isABC =
  ROOT_API_URL === "https://abc-scm.truckxi.com/api/" ||
  ROOT_URL === "https://abc-scm.truckxi.com/api/";
const isTN =
  ROOT_API_URL === "https://tn-scm.truckxi.com/api/" ||
  ROOT_URL === "https://tn-scm.truckxi.com/api/";
const isJML=
  ROOT_API_URL === "https://jml-scm.truckxi.com/api/" ||
  ROOT_URL === "https://jml-scm.truckxi.com/api/";

let renderRadios = props => {
  const titleClass = classNames({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'marginRightLabel', 'marginH4Style')
  return (
    <ButtonToolbar className="payment-type-buttons">
      <Button bsStyle="primary" type="button" style={{ width: 115 }}>
        <div className="radio">
          <label for="notPaid-payment-type">
            <input {...props.input} id="notPaid-payment-type" type="radio" value="Not Paid" name="paymentTypeRadios" checked={props.input.value === "Not Paid" || !(props.input)}/>
            <Translate value="not_paid" />
          </label>
        </div>
      </Button>
      <Button bsStyle="primary" type="button" style={{ width: 115 }}>
        <div className="radio">
          <label for="cash-payment-type">
            <input {...props.input} id="cash-payment-type" type="radio" value="cash"
             name="paymentTypeRadios" checked={props.input.value === "cash"}/>
            <Translate value="cash" />
          </label>
        </div>
      </Button>
      <Button bsStyle="primary" type="button" style={{ width: 115 }}>
        <div className="radio">
          <label for="credit-payment-type">
            <input {...props.input} id="credit-payment-type" type="radio" value="credit_card" name="paymentTypeRadios" checked={props.input.value === "credit_card"}/>
            <Translate value="credit_card" />
          </label>
        </div>
      </Button>
      <Button bsStyle="primary" type="button" style={{ width: 115 }}>
        <div className="radio">
          <label for="check-payment-type">
            <input {...props.input} id="check-payment-type" type="radio" value="check"
             name="paymentTypeRadios" checked={props.input.value === "check"}/>
            <Translate value="check" />
          </label>
        </div>
      </Button>
    </ButtonToolbar>
  )
}

const sortByIndex = (a, b) => b.Index - a.Index

class RowRenderer extends Component {
  render() {
    return (<div onDoubleClick={()=>{this.props.onDoubleClick(this.props.row)}}><ReactDataGrid.Row ref="row" {...this.props} /></div>)
  }
}

RowRenderer.PropTypes = {
  onDoubleClick: React.PropTypes.func
};


class SalesShippingModal extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      // Control state of Modal
      confirmActionOpen: false,
      setWeightOpen: false,
      serialNumOpen: false,
      setBatchOpen: false,
      setBatchesOpen: false,
      orderNum: null,
      numInputFields: 0,
      totalLoaded: null,
      rowChosen: null,
      currentRow: null,
      currentTable: null,
      oldQuantity: 0,
      salesOrders: {
        rows: [],
        sortColumn: null,
        sortDirection: null
      },

      products: {
        rows: [],
        sortColumn: null,
        sortDirection: null
      },

      selectedRowIdx: 0,
      selectedQty: '',
      isSubmitted: false,
      emailContentModalVisibility: false,
      emailSubjectTemplate: '',
      emailContentTemplate: '',
      batches: [],
      selectedRow: undefined,
      selectedProductIdCCW: null,
      rowProduct: null,
    }
    this.openSetWeight = this.openSetWeight.bind(this);
    this.closeSetWeight = this.closeSetWeight.bind(this);
    this.closeSerialNum = this.closeSerialNum.bind(this);
    this.openAction = this.openAction.bind(this);
    this.closeAction = this.closeAction.bind(this);
    this.moveOff = this.moveOff.bind(this);
    this.moveTo = this.moveTo.bind(this);
    this.quickMove = this.quickMove.bind(this);
  }

  componentDidMount() {
    let salesOrders = {};
    if (isSV || isSUN) {
      salesOrders = {...this.state.salesOrders, rows: (this.props.rows || []).map(row => ({
        ...row,
        LoadedQuantity: 0,
      }))};
    } else {
      salesOrders = {...this.state.salesOrders, rows: (this.props.rows || []).sort(sortByIndex).map(row => ({
        ...row,
        LoadedQuantity: 0,
      }))};
    }
    // only for sunset
    if (isSV) {
      const newRows2 = [];
      salesOrders.rows.map((r,i) => {
        if (r.Quantity-r.PickupQuantity > 0) {
          newRows2.push({...r, Quantity: r.Quantity-r.PickupQuantity});
        }
      });
      salesOrders.rows = newRows2;
    }
    // only for ocm
    if ((isOCM && this.props.selectedCompany.value === 2) || isCCW ) {
      let newRows = [];
      this.props.rows.forEach(row => {
        if (row.PickedBatches && row.PickedBatches.length) {
          row.PickedBatches.forEach(pickedBatch => {
            newRows.push({
              ...row,
              Batch_id_id: pickedBatch.Batch_id__pk,
              LoadedQuantity: pickedBatch.Quantity,
              packed: true,
            })
          })
        } else {
          newRows.push(row)
        }
      });
      if (this.props.isMergeSo) {
        newRows = newRows.map((r, idx) => ({
          ...r,
          Index: idx + 1,
        }))
      }
      salesOrders.rows = newRows;
    }
    if(isOLG) {
      let newRows = [...this.props.rows];
      // if (this.props.isMergeSo) {
        newRows = newRows.map((r, idx) => ({
          ...r,
          Index: idx,
        }))
      // }
      salesOrders.rows = newRows;
    }
    this.setState({ salesOrders });
    this.props.setValue('salesShippingModal', 'PaymentType', 'Not Paid');
    this.props.setValue('salesShippingModal', 'InvoiceShipDate', null); //new Date()
    if (isCCW) {
      this.props.setValue('salesShippingModal', 'PostingDate', new Date());
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.PaymentType && nextProps.PaymentType != this.props.PaymentType) {
      this.props.convertingToInvoiceReset();
      this.props.updateSalesInvoiceReset();
    }
    if(nextProps.salesOrderDetail && nextProps.salesOrderDetail != this.props.salesOrderDetail) {
      let sales_Invoice_Lines = nextProps.salesOrderDetail.Sales_Invoice_Lines
      if(isOLG && !sales_Invoice_Lines) return
      let products = { ...this.state.products, rows: sales_Invoice_Lines };
      let salesOrders = {...this.state.salesOrders, rows: this.props.rows};
      let leftRows = [];
      salesOrders.rows.map(r => {
        let index = _.findIndex(sales_Invoice_Lines, {'Index': r.Index })
        if(index == -1) {
          leftRows.push(r);
        }
      })
      salesOrders.rows = leftRows;
      if (!isSV && !isSUN) {
        salesOrders.rows.sort(sortByIndex);
      }
      this.setState({products, salesOrders});
    }
    if(nextProps.salesInvoicePdf && nextProps.salesInvoicePdf !== this.props.salesInvoicePdf) {
      this.setState({ PdfFrameLoaded: false });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.PdfFrameLoaded !== this.state.PdfFrameLoaded && this.state.PdfFrameLoaded == false) {
      return false;
    }
    return true;
  }

  closeSetWeight() {
    this.setState({setWeightOpen: false}, () => {if (this.state.salesOrders.rows.length) ReactDOM.findDOMNode(this.refs['quickLoader'].refs.input).focus();});
  }

  closeSerialNum() {
    this.setState({serialNumOpen: false}, () => {if (this.state.salesOrders.rows.length) ReactDOM.findDOMNode(this.refs['quickLoader'].refs.input).focus();});
  }

  openSetWeight() {
    this.setState({setWeightOpen: true});
  }

  openAction() {
    this.setState({confirmActionOpen: true});
  }

  closeAction() {
    this.setState({confirmActionOpen: false});
  }

  moveOff(row) {
    let salesOrders = {...this.state.salesOrders};
    salesOrders.rows.push(row);
    if (!isSV && !isSUN) {
      salesOrders.rows.sort(sortByIndex);
    }
    let products = {...this.state.products};
    let index = _.findIndex(products.rows, {'Index': row.Index});
    if(index > -1)
      products.rows.splice(index, 1);
    this.setState({products, salesOrders, selectedRowIdx: 0, selectedQty: ''})
    this.props.convertingToInvoiceReset();
    this.props.updateSalesInvoiceReset();
  }

  //not used
  checkMoveToBatch() {
    // this.state.selectedInventoryRow => this.state.salesOrders.rows[parseFloat(this.state.selectedRowIdx)]
    const selectedRow = { ...this.state.salesOrders.rows[parseFloat(this.state.selectedRowIdx)] };
    // const check = _.findIndex(this.state.rows, { ProductNum: selectedInventoryRow.ProductNum });
    const check = _.findIndex(this.state.products.rows, { ProductNum: selectedRow.ProductNum });
    this.moveToBatch();
  }

  //not used
  moveToBatch() {
    let products = {...this.state.products};
    const selectedRow = { ...this.state.salesOrders.rows[parseFloat(this.state.selectedRowIdx)] };
    let newRows = [];

    selectedRow.Batch_id = this.state.Batch_id;
    selectedRow.BatchExpiredDate = this.state.BatchExpiredDate;
    selectedRow.BatchLocation = this.state.BatchLocation;
    selectedRow.LoadedQuantity = this.state.BatchQty;
    selectedRow.TotalNetWeight = this.state.BatchAveWt * this.state.BatchQty;

    products.rows.push(selectedRow);
    // products.rows.unshift(selectedRow);

    // products.rows.sort(sortByIndex);
    let rows = Data.Selectors.getRows(this.state.salesOrders);
    let salesOrders = {...this.state.salesOrders, rows: rows};

    let index = _.findIndex(salesOrders.rows, {'Index': row.Index});
    let newRowIdx = parseFloat(this.state.selectedRowIdx);

    if(index > -1)
      salesOrders.rows.splice(index, 1);
    if (newRowIdx >= salesOrders.rows.length-1){
      newRowIdx = salesOrders.rows.length - 1;
    }
    this.setState({products, salesOrders, selectedRowIdx: newRowIdx, selectedQty: ''})
    this.props.convertingToInvoiceReset();
    this.props.updateSalesInvoiceReset();
  }
  moveTo2(row) {
    if(row.ProductType == 'Non-Fixed' && row.LoadedQuantity > 0) {
    } else {
      moveTo(row)
    }
  }

  moveTo(row) {
    let products = {...this.state.products};
    const selectedRow = { ...this.state.salesOrders.rows[parseFloat(this.state.selectedRowIdx)] };

    if(isGGI && row.ProductType == 'Non-Fixed' && row.Weights && row.Weights != null && row.Weights.length == row.Quantity) {
      let sumWt = 0;
      row.Weights.map(wt=>{
        sumWt += wt;
      })
      products.rows.push({...row, TotalNetWeight: sumWt, TotalPrice: sumWt * row.SmallUnitPrice});
    } else {
      products.rows.push(row);
    }
    // if (!isSV && !isSUN) {
    //   products.rows.sort(sortByIndex);
    // }
    let rows = Data.Selectors.getRows(this.state.salesOrders);
    let salesOrders = {...this.state.salesOrders, rows: rows};
    let index = _.findIndex(salesOrders.rows, {'Index': row.Index});
    let newRowIdx = parseFloat(this.state.selectedRowIdx);

    if(index > -1)
      salesOrders.rows.splice(index, 1);
    if (newRowIdx >= salesOrders.rows.length-1){
      newRowIdx = salesOrders.rows.length - 1;
    }
    this.setState({products, salesOrders, selectedRowIdx: newRowIdx, selectedQty: ''})
    this.props.convertingToInvoiceReset();
    this.props.updateSalesInvoiceReset();
  }

  quickMove(row) {
    let products = {...this.state.products};
    if (!isSV && !isSUN) {
      products.rows.sort(sortByIndex);
    }
    let index = _.findIndex(products.rows, {'Index': row.Index});
    products.rows[index].TotalNetWeight = row.TotalNetWeight;
    products.rows[index].TotalPrice = row.TotalPrice;
    this.setState({products});
    // this.props.convertingToInvoiceReset();
    // this.props.updateSalesInvoiceReset();
  }

  formatDate(date) {
    var formattedDate;
    if (date.getMonth() < 10) {
      formattedDate = '0' + (parseInt(date.getMonth())+1);
    } else {
      // TURN THESE TO STRINGS
      formattedDate = String(parseInt(date.getMonth()+1));
    }

    if (date.getDate() < 10) {
      formattedDate += '0' + date.getDate();
    } else {
      formattedDate += String(date.getDate());
    }

    formattedDate += String(date.getFullYear());
    return formattedDate;
  }

  createInvoice(isPartial, isMergeSo, mergeSoIds) {
    let rows = this.state.products.rows;
    let isMobile = this.context.router.routes.length > 1 && this.context.router.routes[1].path === 'mobileSalesOrders/:id';
    if(isVAK && isMobile) {
      let isLess = [];
      rows.map(item => {
        if(item.LoadedQuantity < item.Quantity) {
          isLess.push(item.RefNum);
        }
      })
      if(isLess.length > 0) {
        alert(`Sku: ${isLess.toString()} is different from the order quantity`)
        this.setState({
          isSubmitted: false,
        })
        return
      }
    }
    if (isABC) {
      rows = rows.filter(row => row.LoadedQuantity)
    }
    let id = this.props.currentSalesOrder.SalesOrder_id;
    if (this.props.isMergeSo) {
      id = this.props.mergeSOIds; // ?
    }

    const partialParams = {}
    if (isOCM || isSV) {
      if (isPartial) {
        partialParams.SaleStatus = isSV ? 'Backorder' : 'Partial';
      } else {
        partialParams.SalesStatus = 'Released';
      }
    }
    if (isCCW) {
      if (isPartial) {
        partialParams.SaleStatus = 'Quote';
      }
    }

    let shipment_info = '';
    if (isSKH || isABCFF) {
      shipment_info = {
        trackingNumber: this.props.trackingNumber,
        shipCarrier: this.props.shipCarrier,
        shipMethod: this.props.shipMethod,
      };
    }
    // here to seperate non_fixed item based on batches
    let newRows = [];
    if (isCCW) {
      rows.map((row) => {
        if (row.Batches && row.Batches.length > 0) {
          row.Batches.map((b) => {
            const batchWeights = [];
            for (let i = 0; i < b.BatchQty; i++) {
              batchWeights.push(b.BatchAveWt);
            }

            delete row.Batches;  // or delete row["Batches"];

            newRows.push({
              ...row,
              Batch_id_id: b.Batch_id_id,
              BatchExpiredDate: b.BatchExpiredDate,
              BatchLocation: b.BatchLocation,
              BatchQty: b.BatchQty,
              LoadedQuantity: b.BatchQty,
              BatchAveWt: b.BatchAveWt,
              TotalNetWeight: b.BatchAveWt * b.BatchQty,
              NetWeight: b.BatchAveWt,
              Weights: batchWeights,
            });
          })
        } else {
          newRows.push(row);
        }
      });
    }
    if (isAP) {
      rows.map((row) => {
        if (row.Batches && row.Batches.length > 0) {
          row.Batches.map((b) => {
            if(b.Batch_id_id) {// have batches
              let newRow = {
                ...row,
                Batch_id_id: b.Batch_id_id,
                BatchExpiredDate: b.BatchExpiredDate,
                BatchLocation: b.BatchLocation,
                BatchQty: b.BatchQty,
                LoadedQuantity: b.BatchQty,
                
              }
              if(row.ProductType == 'Non-Fixed') {
                newRow.Weights = b.weights;
                newRow.TotalNetWeight = b.BatchWeight;
              } else {
                newRow.TotalNetWeight = (parseFloat(b.BatchQty) * row.NetWeight).toFixed(2);
              }
              newRows.push(newRow);
            } else { // no batches
              let newRow = {
                ...row,
                 LoadedQuantity: b.BatchQty,
               }
              if(row.ProductType == 'Non-Fixed') {
                newRow.Weights = b.weights;
                newRow.TotalNetWeight = b.BatchWeight;
              } else {
                newRow.TotalNetWeight = (parseFloat(b.BatchQty) * row.NetWeight).toFixed(2);
              }
              newRows.push(newRow);
            }
          })
        } else {
          newRows.push(row);
        }
      });
    }
    if (isCCW || isAP) {
      this.props.convertToInvoice(id, newRows, this.props.PaymentType, this.props.PaymentNum, partialParams, this.props.InvoiceShipDate, isMergeSo, mergeSoIds, shipment_info, this.props.PostingDate);
    } else {
      this.props.convertToInvoice(id, rows, this.props.PaymentType, this.props.PaymentNum, partialParams, this.props.InvoiceShipDate, isMergeSo, mergeSoIds, shipment_info);
    }
  }

  renderAutoLoadButton = () => {
    // if (isOCM && (this.props.selectedCompany.value === 2)) {
    //   return <div style={{ border: '1px solid red', alignSelf: 'right', overflow: 'right' }}>
    //     <Button bsStyle="primary" type="button" style={{  }} onClick={() => this.autoLoad() }>
    //     <em className="fa fa-mail-forward" /><Translate value="load_fixed" />
    //   </Button>
    //   <Button bsStyle="primary" type="button" style={{  }} onClick={() => this.autoLoad() }>
    //     <em className="fa fa-mail-forward" /><Translate value="load_fixed" />
    //   </Button>
    //   </div>
    // }
    return <Button bsStyle="primary" type="button" style={{ marginLeft: '140px' }} onClick={() => this.autoLoad() }>
      <em className="fa fa-mail-forward" /><Translate value="auto_load" />
    </Button>
  }

  autoLoad() {
    // let productRows = [...this.state.products.rows];
    let salesOrders = {...this.state.salesOrders};
    let products = {...this.state.products};
    salesOrders.rows = salesOrders.rows.map(r => {
      if(r.ProductType != 'Non-Fixed' && (!isVAK || isVAK && r.Attributes2 !== 'finished_parts')) {
        if (isOCM && r.LoadedQuantity) {
          // if is ocm and has loadedQuantity which comes from PickedBatches, dont change loadedqty
        } else {
          r.LoadedQuantity = r.Quantity;
        }
          r.TotalNetWeight = ((parseFloat(r.LoadedQuantity) || 0)*(parseFloat(r.NetWeight) || 0)).toFixed(2)
          products.rows.push(r);
          return null
        // }
        return r
      } else {
        if (isJML) {
          r.LoadedQuantity = r.Quantity;
          r.TotalNetWeight = ((parseFloat(r.LoadedQuantity) || 0)*(parseFloat(r.PackageSize_1) || 0)).toFixed(2)
          r.Weights = Array(r.Quantity).fill(parseFloat(r.PackageSize_1));
          products.rows.push(r);
          return null
        }
        return r;
      }
    })
    salesOrders.rows = salesOrders.rows.filter((obj)=>{
      return obj !== null
    })
    if (!isSV && !isSUN) {
      products.rows.sort(sortByIndex);
    }
    // productRows.map(row => {
    //   if (row.ProductType == "Fixed") {
    //     if (row.LoadedQuantity == 0) {
    //       row.LoadedQuantity = row.Quantity;
    //     }
    //   }
    // });
    //
    // let products = {...this.state.products, rows: productRows};
    this.setState({ products, salesOrders });
    this.props.convertingToInvoiceReset();
    this.props.updateSalesInvoiceReset();
  }

  load(Index) {
    // let productRows = [...this.state.products.rows];
    let salesOrders = {...this.state.salesOrders};
    let products = {...this.state.products};
    let isNonFixed = false;
    salesOrders.rows = salesOrders.rows.map(r => {
      if(r.Index == Index && (r.ProductType == 'Fixed' || r.ProductType == 'Per-Pound')) {
        r.LoadedQuantity = parseFloat(roundTo(this.state.selectedQty, 2));
        r.TotalNetWeight = parseFloat(((parseFloat(r.LoadedQuantity) || 0)*(parseFloat(r.NetWeight) || 0)).toFixed(2));
        products.rows.push(r);
        return null;
      } else if (r.Index == Index && r.ProductType == 'Non-Fixed'){
        r.LoadedQuantity = parseFloat(roundTo(this.state.selectedQty, 2));
        isNonFixed = true;
        return r;
      }
      else{
        return r;
      }
    })

    let index = 0;
    if (!isNonFixed){
      salesOrders.rows = salesOrders.rows.filter((obj)=>{
        return (obj !== null && obj !== undefined)
      })
    } else {
      for (let i = 0; i < salesOrders.rows.length; i++){
        if( salesOrders.rows[i].Index == Index )
          index = i;
      }
      
      if (isCCW && this.props.selectedWarehouse.invoiceSelectBatch === true) {
        this.setState({ currentRow: index, currentTable: 'salesOrders', setBatchOpen: true });
      } else if (isAP) {
        this.setState({ currentRow: index, currentTable: 'salesOrders', setBatchesOpen: true });
      } else {
        this.setState({ currentRow: index, currentTable: 'salesOrders', setWeightOpen: true });
      }
    }

    // let products = {...this.state.products, rows: productRows};
    let newRowIdx = parseFloat(this.state.selectedRowIdx);
    if (newRowIdx >= salesOrders.rows.length-1){
      newRowIdx = salesOrders.rows.length - 1;
    }
    //will need to put this somewhere else
    this.setState({ products, salesOrders, selectedQty: '', selectedRowIdx: newRowIdx});
    this.props.convertingToInvoiceReset();
    this.props.updateSalesInvoiceReset();
  }

  checkRows(isPartial) {
    // here for ccw need to add rows for multiple batch
    this.setState({
      isSubmitted: true
    }, () => {
      if (isTN && !this.props.InvoiceShipDate) {
        alert("Please select a Ship Date to save.");
        return;
      }
      let valid = true;
      let {salesInvoiceDetail, convertToInvoiceSuccess} = this.props;
      if (!isABC) {
        this.state.products.rows.map(row => {
          if (row.LoadedQuantity == 0) {
            this.setState({ confirmActionOpen: true });
            valid = false;
          }
          if(isCCW && row.ProductType == 'Non-Fixed' && parseFloat(row.TotalNetWeight) == 0) {
            alert('The batch weight is incorrect. Please go to the inventory page to modify it!')
            valid = false;
          }
        });
      }
      // if (isABC && this.props.InvoiceNum && !convertToInvoiceSuccess) {
      //   this.createInvoice(isPartial);
      //   return;
      // }
      if ((isOCM || isSV) && valid) {
        this.createInvoice(isPartial, this.props.isMergeSo, this.props.mergeSOIds);
        return;
      }
      if (valid){
        this.createInvoice(isPartial, this.props.isMergeSo, this.props.mergeSOIds);
      } else {
        this.setState({
          isSubmitted: false,
        })
      }
    })
  }

  returnTotalWeight(totalWeight, weights) {
    let currentRow = this.state[this.state.currentTable].rows[this.state.currentRow];
    currentRow.TotalNetWeight = parseFloat(totalWeight);
    if(isGGI) {
      currentRow.TotalPrice = parseFloat(roundTo(((parseFloat(totalWeight) || 0)*(parseFloat(currentRow.SmallUnitPrice) || 0)), 2).toFixed(2));
    } else {
      currentRow.TotalPrice = parseFloat(roundTo(((parseFloat(totalWeight) || 0)*(parseFloat(currentRow.UnitPrice) || 0)), 2).toFixed(2));
    }
    currentRow.Weights = weights;
    if(this.state.currentTable == "salesOrders") {
      this.moveTo(currentRow);
    } else {
      this.quickMove(currentRow);
    }
  }

  setSerialNums(serialNums) {
    const getRows = () => {
      return Data.Selectors.getRows(this.state.products);
    }
    let rows = getRows();
    rows[this.state.currentRow].LoadedQuantity = serialNums;
  }

  returnSerialNums(serialNums) {
    let currentRow = this.state[this.state.currentTable].rows[this.state.currentRow];
    currentRow.SerialNum = serialNums;
    if(this.state.currentTable == "salesOrders") {
      this.moveTo(currentRow);
    } else {
      this.quickMove(currentRow);
    }
  }

  // batch here
  calculateLineMaxQty = (line) => {
    const {
      currentMatchingRowsObject, //new added quantity
    } = this.generateBatchRelatedInfo(line.ProductNum);

    const batchId = line.Batch_id || line.Batch_id_id;
    const batch = this.props.batchesInfo.batches.filter(batch => {
      return batch.id === batchId
    })[0];

    if (!batch) {
      return false;
    }

    const batchMaxQty = batch.quantity;
    const batchAvaliableQty = batchMaxQty - (currentMatchingRowsObject[batchId] || 0);
    return batchAvaliableQty;
  }

  generateBatchRelatedInfo = (ProductNum) => {
    // Found products that are same as selectedInventoryRow on table
    const currentMatchingRows = this.state.products.rows.filter(row => row.ProductNum === ProductNum);

    // batch id and quantity pairs
    const currentMatchingRowsObject = _.reduce(currentMatchingRows, (acc, cur) => {
      let batchId = cur.Batch_id || cur.Batch_id_id;
      if (acc[batchId]) {
        acc[batchId] += parseInt(cur.Quantity);
      } else {
        acc[batchId] = parseInt(cur.Quantity);
      }
      return acc;
    }, {});
    // remove presales
    // if (this.state.products && this.state.products.rows) {
    //   _.forEach(this.state.products.rows, line => {
    //     if (line.SalesOrderLine_id) {
    //       if (currentMatchingRowsObject[line.Batch_id_id]) {
    //         // originQty
    //         currentMatchingRowsObject[line.Batch_id_id] = currentMatchingRowsObject[line.Batch_id_id] - line.originQty;
    //       }
    //     }
    //   });
    // };

    // remove negative quantity batches
    const validBatches = this.props.batchesInfo.batches.filter(batch => (batch.quantity > 0 || batch.is_initial_batch));
    // remove quantities that are newly added from batch
    const batches = _.map(validBatches, batch => {
      if (currentMatchingRowsObject[batch.id]) {
        return {
          ...batch,
          quantity: batch.quantity - currentMatchingRowsObject[batch.id]
        }
      }
      return batch
    });

    //check if product needs more convert GGI
    let totalNewAddedQty = _.reduce(currentMatchingRowsObject, (result, value, key) => {
      return result += parseInt(value);
    }, 0);

    let totalNeededQty = parseInt(this.props.quantityValue) + totalNewAddedQty;
    return {batches, totalNeededQty, currentMatchingRowsObject};
  }

  resetLoadedQty = () => {
    const rows = [...this.state[this.state.currentTable].rows];
    rows[this.state.currentRow].LoadedQuantity = 0;
    this.setState({
      [this.state.currentTable]: {
        ...[this.state.currentTable],
        rows,
      }
    })
  }
  // close
  setMultiBatchModalVisibility = (setBatchOpen = false) => {
    this.setState({setBatchOpen: false}, () => {if (this.state.salesOrders.rows.length) ReactDOM.findDOMNode(this.refs['quickLoader'].refs.input).focus();});
  }

  setNewBatchModalVisibility = (setBatchesOpen) => {
    this.setState({setBatchesOpen: false}, () => {if (this.state.salesOrders.rows.length) ReactDOM.findDOMNode(this.refs['quickLoader'].refs.input).focus();});
  }

  returnBatch(totalWeight, batches) {
    // here move to select batch
    let currentRow = this.state[this.state.currentTable].rows[this.state.currentRow];
    currentRow.TotalNetWeight = parseFloat(totalWeight);
    currentRow.TotalPrice = parseFloat(roundTo(((parseFloat(totalWeight) || 0)*(parseFloat(currentRow.UnitPrice) || 0)), 2).toFixed(2));
    currentRow.Batches = batches;
    if(this.state.currentTable == "salesOrders") {
      this.moveTo(currentRow);
    } else {
      this.quickMove(currentRow);
    }
  }

  renderSalesOrderSelection() {
    let that = this;
    if (this.props.salesOrdersIsLoading && !this.props.salesOrdersError) {
      return <Spinner/>
    } else if (this.props.salesOrdersError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">
            {JSON.stringify(this.props.salesOrdersError)}
          </div>
        </ContentWrapper>
      )
    }
    else {
      // Parameters of the react-data-grid
      let tableHeight = (window.innerHeight < 900) ? 387 : 387;
      const getRows = () => {
        return Data.Selectors.getRows(this.state.salesOrders);
      }

      const getSize = () => {
        return getRows().length;
      }

      const rowGetter = rowIdx => {
        var rows = getRows();
        return rows[rowIdx];
      }

      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        var salesOrders = {...this.state.salesOrders, sortColumn: sortColumn, sortDirection: sortDirection};
        this.setState({ salesOrders });
      }

      const onRowSelect = rows => {
        var salesOrder = {...this.state.salesOrders, selectedRows: rows};
        this.setState({ salesOrders });
      }

      const onRowClick = (rowIdx, row) => {
        if (rowIdx > -1 && isCCW && row.ProductType=="Non-Fixed") {
          this.setState({
            selectedProductIdCCW: row.Product_id,
          });
          this.props.fetchBachesByID(row.Product_id, this.props.Company_id, this.props.Pickup_Warehouse_id);
        }
      }

      // not been used
      function onDoubleClick(e) {
        if (isCCW && this.props.selectedWarehouse.invoiceSelectBatch === true) {
          this.setState({ totalLoaded: row.loaded_quantity, setBatchOpen: true, rowChosen: row.salesOrderLine_id });
        } else {
          this.setState({ totalLoaded: row.loaded_quantity, setWeightOpen: true, rowChosen: row.salesOrderLine_id });
        }
      }

      const handleRowUpdated = e => {
        let rows = getRows();
        let isMobile = this.context.router.routes.length > 1 && this.context.router.routes[1].path === 'mobileSalesOrders/:id';
        if(isVAK && isMobile && e.updated.LoadedQuantity != null) {
          if(e.updated.LoadedQuantity > rows[e.rowIdx].Quantity) {
            alert('Loadedquantity cannot exceed the order quantity ');
            return
          }
        }
        Object.assign(rows[e.rowIdx], e.updated);
        let loadedQuantity = rows[e.rowIdx].LoadedQuantity ? parseFloat(rows[e.rowIdx].LoadedQuantity) : 0;
        let unitPrice = parseFloat(rows[e.rowIdx].UnitPrice) || 0;
        let netWeight = parseFloat(rows[e.rowIdx].NetWeight) || 0;
        if (rows[e.rowIdx].ProductType == "Fixed") {
          rows[e.rowIdx].TotalNetWeight = (loadedQuantity * netWeight).toFixed(2);
          rows[e.rowIdx].TotalPrice = roundTo((loadedQuantity * unitPrice), 2).toFixed(2);
        }
        if(isGGI) {
          unitPrice = parseFloat(rows[e.rowIdx].SmallUnitPrice) || 0;
        }
        if (rows[e.rowIdx].ProductType == "Per-Pound") {
          rows[e.rowIdx].TotalNetWeight = (loadedQuantity * netWeight).toFixed(2);
          rows[e.rowIdx].TotalPrice = roundTo((loadedQuantity * netWeight * unitPrice), 2).toFixed(2);
        }
        let salesOrders = { ...this.state.salesOrders, rows: rows }
        // this.setState({ salesOrders });

        this.setState({
          salesOrders,
          totalLoaded: rows[e.rowIdx].LoadedQuantity,
          rowChosen: rows[e.rowIdx].SalesOrderLine_id,
          rowProduct: rows[e.rowIdx].Product_id,
          currentRow: e.rowIdx,
          currentTable: "salesOrders",
          selectedRow: rows[e.rowIdx],
        }, () => {
          if(rows[e.rowIdx].ProductType == "Non-Fixed") {
            if(!isJML) {
              if (isCCW && this.props.selectedWarehouse.invoiceSelectBatch === true) {
                this.setState({setBatchOpen: true})
              } else if(isAP) {
                this.setState({setBatchesOpen: true})
              } else {
                this.setState({setWeightOpen: true})
              }
            } else {
              const totalWeight = rows[e.rowIdx].PackageSize_1 * loadedQuantity;
              const Weights = [];
              for(let i = 0; i < loadedQuantity; i++) {
                Weights.push(parseFloat(rows[e.rowIdx].PackageSize_1))
              }
              this.returnTotalWeight(totalWeight, Weights);
            }
          } else{
            if (isVAK && rows[e.rowIdx].Attributes2 === 'finished_parts') {
              this.setState({serialNumOpen: true, setWeightOpen: false})
            }
          }
        })
      }

      const IsVariableFormatter = React.createClass({
        render() {
          if (this.props.dependentValues && this.props.dependentValues.ProductType == "Non-Fixed") {
            return <span>{this.props.value} <label className="label label-success"><Translate value="non_fixed" /></label></span>;
          } else if (this.props.dependentValues && this.props.dependentValues.ProductType == 'Per-Pound') {
            return <span>{this.props.value} <label className='label label-primary'><Translate value="per_pound" /></label></span>;
          }
          return <span>{this.props.value} </span>
        }
      });

      // Column difinition
      var RowRenderer2 = React.createClass({
       render: function() {
        if (that.state.salesOrders.rows.length && that.state.salesOrders.rows[parseFloat(that.state.selectedRowIdx)].Index  === this.props.row.Index)
          return (<div style={{color: 'blue'}} onDoubleClick={()=>{this.props.onDoubleClick(this.props.row)}}><ReactDataGrid.Row ref="row" {...this.props} /></div>);
        return (<div onDoubleClick={()=>{this.props.onDoubleClick(this.props.row)}}><ReactDataGrid.Row ref="row" {...this.props} /></div>);
       }
      });

      const columns = [
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80
        },
        ...isAFM ? [{
          key: 'Barcode',
          name: <Translate value="barcode" />,
          resizable: true,
          sortable: true,
          width: 100,
        }]: [{
          key: 'RefNum',
          name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
          resizable: true,
          sortable: true,
          width: 80
        },],
        ...isAFM ? [{
          key: 'Brand',
          name: <Translate value="brand" />,
          resizable: true,
          sortable: true,
          width: 100,
        }]: [],
        {
          key: 'Name',
          name: <Translate value="name" />,
          resizable: true,
          sortable: true,
          width: 160,
        },
        ...!(isLAP || isAPD) ? [{
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: 95,
        }]: [],
        {
          key: 'Quantity',
          name: <Translate value="qty" />,
          resizable: true,
          sortable: true,
          formatter: IsVariableFormatter,
          width: (isSH || isAP) ? 80 : 100,
          getRowMetaData: (row) => row,
        },
        ...!isSV ? [{
          key: 'LoadedQuantity',
          name: <Translate value="loaded_qty" />,
          resizable: true,
          sortable: true,
          width: (isSH || isAP) ? 80 : 100,
          editable: true,
        }] : [],
      ]

      if(isSH || isAP) {
        columns.push({
          key: 'PickedQuantity',
          name: <Translate value='picked_qty' />,
          resizable: true,
          sortable: true,
          width: 100,
        })
      }
      if (isOCM || isSV || isCCW) {
        columns.push({
          key: 'PickupQuantity',
          name: <Translate value="invoiced_qty" />,
          resizable: true,
          sortable: true,
          width: 100,
          editable: true,
        })
      }

      return (
        <Row><Col xs={ 12 }><div style={{ maxWidth: '100%' }} id="SalesShippingModal-dataGrid1">
            <ReactDataGrid
              // rowRenderer={<RowRenderer2 onDoubleClick={ isCCW ? this.moveTo2 : this.moveTo}/>}
              rowKey='Index'
              // rowKey={Math.random()}
              rowRenderer={<RowRenderer2 onDoubleClick={this.moveTo}/>}
              // onGridSort={handleGridSort}
              columns={columns}
              rowHeight={35}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              enableCellSelect={true}
              // onRowClick={onRowClick}
              onRowUpdated={handleRowUpdated}
              minHeight={tableHeight}
              onRowSelect={onRowSelect}
            />
        </div></Col></Row>
      )
    }
  }

  renderSalesOrderDetail() {
    let that = this;
    if (this.props.salesOrderIsLoading && !this.props.salesOrderError) return <Spinner/>
    else if (this.props.salesOrderError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.salesOrderError)}</div></ContentWrapper>
    else {
      // Parameters of the react-data-grid
      let tableHeight = (window.innerHeight < 900) ? 405 : 405;

      const getRows = () => {
        return Data.Selectors.getRows(this.state.products);
      }

      const getSize = () => {
        return getRows().length;
      }

      const rowGetter = rowIdx => {
        var rows = getRows();
        return rows[rowIdx];
      }

      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        var products = {...this.state.products, sortColumn: sortColumn, sortDirection: sortDirection};
        this.setState({products});
      }

      const onRowClick = (rowIdx, row) => {
        // this.props.fetchSalesOrderDetail(row.SalesOrder_id);
        // this.setState({ orderNum: row.SONum });
        if (rowIdx > -1 && isCCW && row.ProductType=="Non-Fixed") {
          this.setState({
            selectedProductIdCCW: row.Product_id,
          });
          this.props.fetchBachesByID(row.Product_id, this.props.Company_id, this.props.Pickup_Warehouse_id);
        }
      }

      function onDoubleClick(e) {
        if (isCCW && this.props.selectedWarehouse.invoiceSelectBatch === true) {
          this.setState({ totalLoaded: row.loaded_quantity, setBatchOpen: true, rowChosen: row.salesOrderLine_id, rowProduct: rows[e.rowIdx].Product_id });
        } else {
          this.setState({ totalLoaded: row.loaded_quantity, setWeightOpen: true, rowChosen: row.salesOrderLine_id });
        }
      }

      const handleRowUpdated = e => {
        let rows = getRows();
        let oldQuantity = rows[e.rowIdx].LoadedQuantity || 0;
        let isMobile = this.context.router.routes.length > 1 && this.context.router.routes[1].path === 'mobileSalesOrders/:id';
        if(isVAK && isMobile && e.updated.LoadedQuantity != null) {
          if(e.updated.LoadedQuantity > rows[e.rowIdx].Quantity) {
            alert('Loadedquantity cannot exceed the order quantity ');
            return
          }
        }
        Object.assign(rows[e.rowIdx], e.updated);
        let loadedQuantity = rows[e.rowIdx].LoadedQuantity ? parseFloat(rows[e.rowIdx].LoadedQuantity) : 0;
        let unitPrice = parseFloat(rows[e.rowIdx].UnitPrice) || 0;
        let netWeight = parseFloat(rows[e.rowIdx].NetWeight) || 0;
        if (rows[e.rowIdx].ProductType == "Fixed") {
          rows[e.rowIdx].TotalNetWeight = (loadedQuantity * netWeight).toFixed(2);
          rows[e.rowIdx].TotalPrice = roundTo((loadedQuantity * unitPrice), 2).toFixed(2);
        }
        if(isGGI) {
          unitPrice = parseFloat(rows[e.rowIdx].SmallUnitPrice) || 0;
        }
        if (rows[e.rowIdx].ProductType == "Per-Pound") {
          rows[e.rowIdx].TotalNetWeight = (loadedQuantity * netWeight).toFixed(2);
          rows[e.rowIdx].TotalPrice = roundTo((loadedQuantity * netWeight * unitPrice), 2).toFixed(2);
        }
        let products = { ...this.state.products, rows: rows }
        this.setState({
          products,
          totalLoaded: rows[e.rowIdx].LoadedQuantity,
          rowChosen: rows[e.rowIdx].SalesOrderLine_id,
          rowProduct: rows[e.rowIdx].Product_id,
          currentRow: e.rowIdx,
          currentTable: "products",
          selectedRow: rows[e.rowIdx],
        }, () => {
          if(rows[e.rowIdx].ProductType == "Non-Fixed") {
            if(!isJML) {
              if (isCCW && this.props.selectedWarehouse.invoiceSelectBatch === true) {
                this.setState({oldQuantity, setBatchOpen: true})
              } else if (isAP) {
                this.setState({oldQuantity, setBatchesOpen: true})
              } else {
                this.setState({oldQuantity, setWeightOpen: true})
              }
            } else {
              const totalWeight = rows[e.rowIdx].PackageSize_1 * loadedQuantity;
              const Weights = [];
              for(let i = 0; i < loadedQuantity; i++) {
                Weights.push(parseFloat(rows[e.rowIdx].PackageSize_1))
              }
              this.returnTotalWeight(totalWeight, Weights);
            }
          }else{
            if (isVAK && rows[e.rowIdx].Attributes2 === 'finished_parts') {
              this.setState({oldQuantity, serialNumOpen: true, setWeightOpen: false})
            }
          }
        })
        this.props.convertingToInvoiceReset();
        this.props.updateSalesInvoiceReset();
      }

      // var RowRenderer = React.createClass({
      //
      //  render: function() {
      //    return (<div onClick={()=>{console.log("on click, move")}}><ReactDataGrid.Row ref="row" {...this.props} onDoubleClick={this.props.onDoubleClick} /></div>)
      //  }
      // });
      //
      // RowRenderer.PropTypes: {
      //   onDoubleClick: React.PropTypes.func
      // }

      // Custom Formatter component
      const IsVariableFormatter = React.createClass({
        render() {
          if (this.props.dependentValues && this.props.dependentValues.ProductType == "Non-Fixed") {
            return <span>{this.props.value} <label className="label label-success"><Translate value="non_fixed" /></label></span>;
          } else if (this.props.dependentValues && this.props.dependentValues.ProductType == 'Per-Pound') {
            return <span>{this.props.value} <label className='label label-primary'><Translate value="per_pound" /></label></span>;
          }
          return <span>{this.props.value} </span>
        }
      });

      // Column difinition
      const columns = [
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80
        },
        {
          key: 'RefNum',
          name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
          resizable: true,
          sortable: true,
          width: 80
        },
        {
          key: 'Name',
          name: <Translate value="name" />,
          resizable: true,
          sortable: true,
          width: 100
        },
        ...!(isLAP || isAPD) ? [{
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: 100,
        }]: [],
        ...!isSV ? [{
          key: 'PackageSize',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
        }] : [],
        {
          key: 'Quantity',
          name: <Translate value="qty" />,
          resizable: true,
          sortable: true,
          width: (isSH || isAP) ? 80 : 110,
          formatter: IsVariableFormatter,
          getRowMetaData: (row) => row,
        },
        {
          key: 'LoadedQuantity',
          name: <Translate value="loaded_qty" />,
          resizable: true,
          sortable: true,
          width: (isSH || isAP) ? 80 :100,
          editable: true,
        },
        ...!isSV ? [{
          key: 'TotalNetWeight',
          name: <Translate value="total_wt" />,
          resizable: true,
          sortable: true,
          width: 100,
        }] : [],
        ...!isSV ? [{
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 100,
        }] : [],
      ]

      if (isABC) {
        const index1 = _.findIndex(columns, { key: "PackageSize" });
        const index2 = _.findIndex(columns, { key: "LoadedQuantity" });
        const index3 = _.findIndex(columns, { key: "Description" });

        columns.splice(index1, 1);
        columns.splice(index2, 1);
        columns.splice(index3, 1, {
          key: 'Description',
          name: <Translate value="desc_editable" />,
          resizable: true,
          sortable: true,
          width: 95,
          editable: true,
        });
      }
      if(isSH || isAP) {
        columns.push({
          key: 'PickedQuantity',
          name: <Translate value='picked_qty' />,
          resizable: true,
          sortable: true,
          width: 100,
        })
      }

      if (isOCM || isSV || isCCW) {
        const QuantityIndex = _.findIndex(columns, { key: 'Quantity'});
        const PickupQuantityCol = {
          key: 'PickupQuantity',
          name: <Translate value="invoiced_qty" />,
          resizable: true,
          sortable: true,
          width: 100,
        }
        columns.splice(QuantityIndex, 0, PickupQuantityCol);
      }

      return (
        <Row><Col xs={ 12 }><div style={{ maxWidth: '100%' }} id="SalesShippingModal-dataGrid2">
          <ReactDataGrid
            // rowKey='Product_id'
            rowKey="Index"
            rowRenderer={<RowRenderer onDoubleClick={this.moveOff}/>}
            onGridSort={handleGridSort}
            columns={columns}
            rowHeight={35}
            // onRowClick={onRowClick}
            enableCellSelect={true}
            rowGetter={rowGetter}
            rowsCount={getSize() }
            minHeight={tableHeight}
            onRowUpdated={handleRowUpdated}
          />
        </div></Col></Row>
      )
    }
  }

  IFrameIsLoaded = () => {
    if (!this.state.PdfFrameLoaded) {
      var pdfFrame = window.frames["Pdf"];
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ PdfFrameLoaded: true });
    }
  }

  renderIFrame() {
    if (this.props.salesInvoicePdf) {
      var file = window.URL.createObjectURL(this.props.salesInvoicePdf);
      return (
          <iframe style={{ display: 'none'}} onLoad={this.IFrameIsLoaded} id="Pdf" name="Pdf" src={file} />
      );
    }
  }

  renderPrint() {
    let pk = (this.props.convertToInvoiceSuccess && this.props.convertToInvoiceSuccess.SalesInvoice_id) || this.props.currentSalesOrder.SalesInvoice_id || (this.props.salesInvoiceDetail && this.props.salesInvoiceDetail.SalesInvoice_id);
    if(!pk)
      return;
    if((!this.props.convertToInvoiceSuccess && !this.props.currentSalesOrder.InvoiceNum)) {
      return
    }
    let shipping_url = ROOT_URL + 'v1/sale/printinvoice/' + pk + "?Bearer=" + localStorage.getItem('token');
    return(
      <Button
        bsStyle='primary'
        // className="position-print-invoice-btn-relative"
        disabled={this.props.requestingSalesInvoicePdf}
        type='button'
        onClick={() => {
          this.props.printSalesInvoice(pk);
        }}
      >
        <em className='fa fa-print' /><Translate value="print_invoice" />
      </Button>
    )
  }
  genSubjectTemplate = () => {
    const invoiceNum = this.props.convertToInvoiceSuccess.InvoiceNum
    const activeCompany = getLocalStorageData('selectedCompany').label;
    return `Invoice ${invoiceNum} from ${activeCompany.toUpperCase()}`
  }
  safeRound = (number, digits) => {
    const decimalPlaces = digits || 0;
    const multiplicator = 10 ** decimalPlaces;
    const expandedNumber = parseFloat((number * multiplicator).toFixed(11));
    return Math.round(expandedNumber) / multiplicator;
  };
  genContentTemplate = () => {
    const invoiceNum = this.props.convertToInvoiceSuccess.InvoiceNum
    const finalPrice = this.safeRound(this.props.convertToInvoiceSuccess.FinalPrice, 2);
      const activeCompany = getLocalStorageData('selectedCompany').label;
      return `Dear Customer:
        Your invoice- ${invoiceNum} for ${finalPrice} is attached. Please remit payment at your earliest convenience.
        Thank you for your business - we appreciate it very much.

        Sincerely,       
        ${activeCompany.toUpperCase()}.`
  }
  handleEmailContentConfirm = (subject, content, email, phone, sendEmail, source) => {
    let data = {
      subject,
      content,
      send_to: phone,
      email_to: sendEmail,
      source
    }
    const success = () => {
      alert('success!');
      this.setState({
        emailSubjectTemplate: '',
        emailContentTemplate: '',
        emailContentModalVisibility: false
      })
    }

    const failed = (err = 'UNKNOWN') => {
      alert(err);
    }
    this.props.emailSelectedSalesInvoices(this.props.convertToInvoiceSuccess.SalesInvoice_id, data, success, failed,);
    this.handleEmailContentClose();
  }

  handleEmailContentClose = () => {
    this.setState({
      emailContentModalVisibility: false,
      emailSubjectModalTemplate: '',
      emailContentModalTemplate: ''
    })
  }
  renderEmailSI() {
    let pk = (this.props.convertToInvoiceSuccess && this.props.convertToInvoiceSuccess.SalesInvoice_id) || this.props.currentSalesOrder.SalesInvoice_id || (this.props.salesInvoiceDetail && this.props.salesInvoiceDetail.SalesInvoice_id);
    if(!pk)
      return;
    if((!this.props.convertToInvoiceSuccess && !this.props.currentSalesOrder.InvoiceNum)) {
      return
    }
    return(
      <Button
        bsStyle="primary"
        className="print-btn"
        type="button"
        onClick={() => {
          this.setState({
            emailSubjectTemplate: this.genSubjectTemplate(),
            emailContentTemplate: this.genContentTemplate(),
            emailContentModalVisibility: true,
            source: "SI",
          })
        }}
      >
        <Translate value="email_SI" />
      </Button>
    )
  }

  renderPaymentNum() {
    if(this.props.PaymentType && this.props.PaymentType == "Check") {
      return (
        <Row className="position-relative">
          <Col xs={ 12 }><label><Translate value="check_no" /></label></Col>
          <Col xs={ 12 }><Field name="PaymentNum" component={ InputField } placeholder="Enter check no."  /></Col>
        </Row>
      )
    }
    else {
      return
    }
  }

  renderShipmentInfo() {
    return (
      <div>
        <Col xs={2}>
          <label><Translate value="tracking_num" /></label>
        <Field name="trackingNumber" component={ InputField } placeholder="Enter tracking no."  />
        </Col>
        <Col xs={2}>
          <label><Translate value="carrier" /></label>
          <Field name="shipCarrier" component={ InputField } placeholder="Enter carrier."  />
        </Col>
        <Col xs={2}>
          <label><Translate value="ship_method" /></label>
          <Field name="shipMethod" component={ InputField } placeholder="Enter ship method."  />
        </Col>
      </div>
    )
  }


  keepLoaded = (oldLoaded) => {
    let products = {...this.state.products};
    if (oldLoaded || (isOLG && oldLoaded == 0)) {
      products.rows[this.state.currentRow].LoadedQuantity = oldLoaded;
    }
    this.setState({ products });
  }

  handleKeyPress = (event) => {
    if(event.charCode == 13 && parseFloat(this.state.selectedQty) && this.state.selectedQty){
      event.preventDefault();
      let rows = Data.Selectors.getRows(this.state.salesOrders);
      const { selectedRowIdx } = this.state;
      let salesOrders = { ...this.state.salesOrders, rows: rows }
      this.setState({
        salesOrders,
        totalLoaded: this.state.selectedQty || 0,
        rowChosen: rows[parseFloat(selectedRowIdx)].SalesOrderLine_id,
        currentRow: parseFloat(selectedRowIdx),
        currentTable: 'salesOrders',
        selectedRow: rows[parseFloat(selectedRowIdx)],
      }, () => {
        this.load(rows[selectedRowIdx].Index);
      })
    } else if (event.charCode == 13){
      let rows = Data.Selectors.getRows(this.state.salesOrders);
      const { selectedRowIdx } = this.state;
      let newRowIdx = 0;
      if (rows.length && parseFloat(selectedRowIdx) < (rows.length-1))
        newRowIdx = parseFloat(selectedRowIdx) + 1;
      this.setState({
        selectedRowIdx: newRowIdx,
        selectedQty: '',
        totalLoaded: this.state.selectedQty || 0,
        rowChosen: rows[parseFloat(selectedRowIdx)].SalesOrderLine_id,
        currentRow: parseFloat(selectedRowIdx),
        currentTable: 'salesOrders'
      });
    }
  }

  handleChange = event => {
    this.setState({selectedQty: event.target.value});
  }

  handleFocus = event => {
    // const {selectedRowIdx } = this.state;
    // let rows = Data.Selectors.getRows(this.state.salesOrders);
    // let row = rows[selectedRowIdx];
    // this.setState({
    //   selectedProductIdCCW: row.Product_id,
    // })
    // this.props.fetchBachesByID(row.Product_id, this.props.Company_id, this.props.Pickup_Warehouse_id);
  }

  handlePutInSubmit = (package_date, weight, success, failed) => {
    const {
      currentTable,
      currentRow,
    } = this.state;
    const Product_id = this.state[currentTable].rows[currentRow].Product_id;

    const payload = {
      location: `${this.props.selectedWarehouse.warehouse_num}-loading`,
      products: [{
        id: null,
        product_id: Product_id,
        quantity: 1,
        package_date: package_date,
        expDate: moment(package_date, 'MM-DD-YY').add(90, 'days').format('MM-DD-YY'),
        weight: weight,
      }],
      warehouse_id: this.props.selectedWarehouse.value,
    };
    this.props.handlePutInSubmit(payload, success, failed)
  }

  fetchBatches = () => {
    const {
      currentTable,
      currentRow,
    } = this.state;
    const Product_id = this.state[currentTable].rows[currentRow].Product_id;
    this.props.fetchBachesByID(Product_id, this.props.Company_id, this.props.Pickup_Warehouse_id);
  }


  renderQuickLoader = () =>{
    let rowName = '';
    let rows = Data.Selectors.getRows(this.state.salesOrders);
    const { selectedQty, selectedRowIdx } = this.state;
    if (rows.length && selectedRowIdx < rows.length){
      if (isOCM || isSV){
        rowName = (rows[parseFloat(selectedRowIdx)].RefNum || "")+ "  " + (rows[parseFloat(selectedRowIdx)].Description || "") +  "  " + (rows[parseFloat(selectedRowIdx)].PackageSize || "");
      } else {
        rowName = (rows[parseFloat(selectedRowIdx)].ProductNum || "")+ "  " + (rows[parseFloat(selectedRowIdx)].Name || "") +  "  " + (rows[parseFloat(selectedRowIdx)].Description || "");
      }
    }
    if (rowName.length && rowName.length >= 54){
      rowName = rowName.substring(0, 53);
      rowName += '...';
    }
    return (
      <Panel className='quick-loader-panel'>
        {
          (rows.length) ?
            <Col xs={ 9 } >
              <label className="quick-loader-label">
                <span className="quick-loader-text">{rowName}</span>
              </label>
            </Col>:
            <Col style={{ 'display': 'block', 'text-align': 'center'}}>
              <label className="quick-loader-label">
                <span className="quick-loader-text" style={{ 'color': '#5cb85c' }}><Translate value="msg_products_loaded_click_save_to_complete" /></span>
              </label>
            </Col>
        }
        {
        (rows.length) ?
          <Col xs={ 3 } className="quick-loader-input">
            <Input
              type="number"
              autoFocus
              placeholder={I18n.t('loaded_qty')}
              ref='quickLoader'
              withRef={true}
              value={this.state.selectedQty}
              onChange={this.handleChange}
              onFocus={this.handleFocus}
              onKeyPress={(event) => {this.handleKeyPress(event)}}
            />
          </Col>:
          <span/>
        }
      </Panel>
    )
  }
  renderQuoteButton = () => {
    return (
      <Button
        bsStyle="primary"
        type="button"
        disabled={
          this.state.isSubmitted ||
          this.props.convertingToInvoice ||
          this.props.salesInvoiceIsUpdating
        }
        onClick={debounce(() => this.checkRows(true), 300)}
      >
        <em className="fa fa-save" /><Translate value="quote" />
      </Button>
    )
  }
  renderSaveButton = () => {
    let {salesOrders} = this.state;
    let olgDisable = false;
    if (salesOrders && salesOrders.rows && salesOrders.rows.length > 0) {
      olgDisable = true;
    }
    let route = this.context.router.routes[1].path
    let loadedQtyCompleteFlag = isVAK && this.state.products.rows.filter(item => item.LoadedQuantity == 0).length
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={
          (isOLG && olgDisable) ||
          (!this.props.isMergeSo && ((isOLG && !route === 'salesOrders/new' || !isOLG) && this.props.salesOrderDetail == null || this.props.convertingToInvoice || this.props.convertToInvoiceSuccess)) ||
          this.state.isSubmitted ||
          loadedQtyCompleteFlag ||
          this.props.convertingToInvoice ||
          this.props.salesInvoiceIsUpdating
        }
        onClick={debounce(() => this.checkRows(), 300)}
      >
        <em className="fa fa-save" /><Translate value="complete" />
      </Button>
    )
  }

  renderPartialSaveButton = () => {
    if (!isOCM && !isSV) return null;
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={(this.props.salesOrderDetail == null || this.props.convertingToInvoice || this.props.convertToInvoiceSuccess) || this.state.isSubmitted}
        onClick={debounce(() => this.checkRows(true), 300)}
      >
        <em className="fa fa-save" /><Translate value="partial_save" />
      </Button>
    )
  }

  render() {
    const { savings, discount, taxRate } = this.props;

    let createDialogStyle = {
      width: '500px',
      height: '600px',
      top: '45%',
      marginLeft: '-10%',
    };
    let MultiBatchStyle ={
      width: '950px',
      height: '550px',
      marginLeft: '-10%'
    }
    let newMultiBatchStyle ={
      width: '60%',
      height: '550px',
      marginLeft: '-32%'
    }
    let createSerialNumDialogStyle = {
      width: '500px',
      height: '500px',
      top: '45%',
      marginLeft: '-10%',
    }

    let totalUnit = 0;
    let totalUnitProducts = 0;
    let totalNetWeight = 0;
    let totalPrice = 0;
    let finalPrice = 0;
    let salesOrdersRows = this.state.salesOrders.rows || [];
    let productsRows = this.state.products.rows || [];
    let currentBatches = (productsRows[this.state.currentRow]) ? this.state.products.rows[this.state.currentRow].Batches : [];
    let currentWeights = (productsRows[this.state.currentRow]) ? this.state.products.rows[this.state.currentRow].Weights : [];
    let currentSerialNo = (productsRows[this.state.currentRow]) ? this.state.products.rows[this.state.currentRow].SerialNum : [];
    let weightsTitle = 'Set Product Weights: ';
    let totalTax = 0;
    const { currentTable, currentRow } = this.state;
    if(currentTable && this.state[currentTable].rows.length && this.state[currentTable].rows[currentRow]){
      weightsTitle = this.state[currentTable].rows[currentRow].ProductNum + ' ' + this.state[currentTable].rows[currentRow].Name;
    }
    salesOrdersRows.map(r => {
      totalUnit += parseFloat(r.Quantity) || 0
    })
    productsRows.map(r => {
      totalUnitProducts += parseFloat(r.LoadedQuantity) || 0
      totalNetWeight += parseFloat(r.TotalNetWeight) || 0
      totalPrice += parseFloat(r.TotalPrice) || 0
      if (r.IsTaxable === true) {
        totalTax += r.TotalPrice*(taxRate/100);
      }
    })
    totalNetWeight = parseFloat(Math.round(totalNetWeight*100)/100).toFixed(2)
    if (isMyumyu || isAFG || isWecom || isAFM) {
      if (discount === 0  && savings > 0) {
        finalPrice = parseFloat((Math.round(totalPrice*100)/100) + roundTo(parseFloat(this.props.currentSalesOrder.Delivery) + totalTax - savings, 2)).toFixed(2);
      } else if (discount > 0) {
        finalPrice = parseFloat((Math.round(totalPrice*100)/100) + roundTo(parseFloat(this.props.currentSalesOrder.Delivery) + totalTax - (totalPrice*(discount/100)), 2)).toFixed(2);
      } else {
        finalPrice = parseFloat((Math.round(totalPrice*100)/100) + roundTo(parseFloat(this.props.currentSalesOrder.Delivery) + totalTax, 2)).toFixed(2);
      }
      totalPrice = parseFloat((Math.round(totalPrice*100)/100) + roundTo(parseFloat(this.props.currentSalesOrder.Delivery), 2)).toFixed(2);
    } else {
      totalPrice = parseFloat((Math.round(totalPrice*100)/100)).toFixed(2);
    }
    // isMyumyu ? totalPrice = parseFloat((Math.round(totalPrice*100)/100) + roundTo(parseFloat(this.props.currentSalesOrder.Delivery), 2)).toFixed(2) : totalPrice = parseFloat((Math.round(totalPrice*100)/100)).toFixed(2)
    if (isGGI) {
      finalPrice = totalPrice;
    }
    return (
      <ContentWrapper>
        <Row className="success-message">
          { (this.props.convertingToInvoice || this.props.salesInvoiceIsUpdating) && <div><Spinner/><Translate value="uploading" /></div> }
          { ((this.props.convertToInvoiceSuccess && !this.props.refreshConvertingToInvoice) || this.props.salesInvoiceUpdated) && !(this.props.convertingToInvoice || this.props.salesInvoiceIsUpdating) &&
            <div className="alert alert-success">
              <span><Translate value="saved" /> </span>
              <span><Translate value="your_sales_invoice_no_is" /> </span>
              {(this.props.salesInvoiceUpdated && this.props.salesInvoiceUpdated.InvoiceNum)||(this.props.convertToInvoiceSuccess && this.props.convertToInvoiceSuccess.InvoiceNum)}
            </div>}
          { this.props.convertToInvoiceFailure &&
            <div className="alert alert-danger marginTopStyle" >
              {this.props.convertToInvoiceError}
              <Button
                bsStyle="primary"
                type="button"
                onClick={() => {
                  this.props.clearConvertingToInvoice();
                  this.setState({
                    isSubmitted: false
                  })
                }}
              >
                <div><label>X</label></div>
              </Button>
            </div>
          }
          { this.props.salesInvoiceUpdateError &&
            <div className="alert alert-danger marginTopStyle" >
              {this.props.salesInvoiceUpdateError.detail}
              <Button
                bsStyle="primary"
                type="button"
                onClick={() => {
                  this.props.clearUpdateSalesInvoice();
                  this.setState({
                    isSubmitted: false
                  })
                }}
              >
                <div><label>X</label></div>
              </Button>
            </div>
          }
        </Row>
        <Row>
          <Col xs={ 5 }>
            <h3><Translate value="sales_order_no" />:{this.props.isMergeSo ? this.props.mergeSONums : this.props.currentSalesOrder.SONum}</h3>
          </Col>
          {isTN &&
            <div>
              <Col xs={2}>
                <h4 className="filter-title"><Translate value="ship_date" /><span style={{color:'red'}}>*</span><span className="colon">:</span></h4>
              </Col>
              <Col xs={2} style={{ paddingTop: '10px' }}>
                <Field component={DatePicker} name="InvoiceShipDate"></Field>
              </Col>
            </div>
          }
        </Row>
        <Row className="set-height">
          <Col xs={ 5 }>
            <h4><Translate value="cust_name" />: {this.props.currentSalesOrder.Deliver_CustomerName}</h4>
          </Col>
          {
            !isSKH &&
            <Col xs={ 1 }>
              <h4 className="filter-title"><Translate value="payment" /><span className="colon">:</span></h4>
            </Col>
          }
          {
            !isSKH &&
            <Col xs={ 4 }>
              <Field name="PaymentType" component={ renderRadios } />
            </Col>
          }
          <Col xs={ 2 }>
            {this.renderPaymentNum()}
          </Col>
        </Row>
        {
          isCCW &&
          <Row>
            <Col xs={ 5 }>
            </Col>
            <Col xs={ 1 }>
              <h4 className="filter-title"><Translate value="posting" /><span className="colon">:</span></h4>
            </Col>
            <Col xs={ 1 }>
              <Field name="PostingDate" component={DatePicker}/>
            </Col>
          </Row>
        }
        {
          (isSKH || isABCFF) &&
          <Row>
            {this.renderShipmentInfo()}
          </Row>
        }
        <Row>
          <Col xs={ 5 }>
            {this.renderQuickLoader()}
            <Panel className="table-collapse-fix-pre">
              <Row className="panel-toolbar">
                {this.renderAutoLoadButton()}
                <Col xs={ 3 }>
                  <label className="marginRightLabel"><Translate value="total_prod" />:</label>
                  {this.state.salesOrders.rows.length}
                </Col>
                <Col xs={ 3 }>
                  <label className="marginRightLabel"><Translate value="total_unit" />:</label>
                  {totalUnit}
                </Col>
              </Row>
              {this.renderSalesOrderSelection()}
            </Panel>
          </Col>
          <Col xs={ 7 }>
            <Panel className="table-collapse-fix">
              <Row>
                <ButtonToolbar className="pull-right">
                  {this.renderPrint()}
                  {this.renderPartialSaveButton()}
                  {(isLAP || isAPD) && this.renderEmailSI() }
                  {!isSV && this.renderSaveButton()}
                  {isCCW && this.renderQuoteButton()}
                  {/*  <Button className="btn btn-primary pull-right" onClick={() => {this.createInvoice()} }><Translate value="save" /></Button>*/}
                </ButtonToolbar>
              </Row>
              <Row>
                <Col xs={ 12 }>
                  <Row className="panel-toolbar">
                    <Col xs={ 3 }>
                      <label className="marginRightLabel"><Translate value="total_prod" />:</label>
                      {this.state.products.rows.length}
                    </Col>
                    <Col xs={ 3 }>
                      <label className="marginRightLabel"><Translate value="total_unit" />:</label>
                      {totalUnitProducts}
                    </Col>
                    <Col xs={ 3 }>
                      <label className="marginRightLabel"><Translate value="total_weight" />:</label>
                      {totalNetWeight}
                    </Col>
                    {/* <Col xs={ 3 }>
                      <label className="marginRightLabel"><Translate value="total_price" />:</label>
                      <span className="dollar-sign">$</span><span>{finalPrice}</span>
                    </Col> */}
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col xs={ 12 }>
                  {this.renderSalesOrderDetail()}
                </Col>
              </Row>
            </Panel>
          </Col>
        </Row>
        {this.renderIFrame()}
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.setWeightOpen}
          onCloseClicked={() => { this.closeSetWeight() }}
          title={weightsTitle}>
          <SetWeightModal
            closeC={this.closeSetWeight}
            totalLoaded={ this.state.totalLoaded }
            rowChosen={ this.state.rowChosen }
            returnTotalWeight={ this.returnTotalWeight.bind(this) }
            currentTable={ this.state.currentTable }
            keepLoaded={this.keepLoaded}
            oldLoaded={this.state.oldQuantity}
            currentWeights={currentWeights}
            setWeights={()=>{}}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={MultiBatchStyle}
          isVisible={this.state.setBatchOpen}
          onCloseClicked={() => {
            this.setMultiBatchModalVisibility();
            this.resetLoadedQty();
          }}
          title={<Translate value="assign_batch"/>}>
          <BatchModal
            closeC={this.setMultiBatchModalVisibility}
            setMultiBatchModalVisibility={this.setMultiBatchModalVisibility}
            batchesInfo={this.props.batchesInfo}
            selectedInventoryRow={this.state.salesOrders.rows[parseFloat(this.state.selectedRowIdx)]}
            selectedproductRow={this.state.products.rows[parseFloat(this.state.currentRow)]}
            quantityValue={this.state.totalLoaded}
            rows={this.state.rows}
            generateBatchRelatedInfo={this.generateBatchRelatedInfo}
            returnBatch={this.returnBatch.bind(this)}
            rowProduct={this.state.rowProduct}
            keepLoaded={this.keepLoaded}
            oldLoaded={this.state.oldQuantity}
            currentBatches={currentBatches}
            selectedWarehouse={this.props.selectedWarehouse}
            fetchProductBatches={this.fetchProductBatches}
            selectedProductIdCCW={this.state.selectedProductIdCCW}
            fetchBatches={this.fetchBatches}
            handlePutInSubmit={this.handlePutInSubmit}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={newMultiBatchStyle}
          isVisible={this.state.setBatchesOpen}
          onCloseClicked={() => {
            this.setNewBatchModalVisibility();
            this.resetLoadedQty();
          }}
          title={<Translate value="assign_batch"/>}>
          <NewBatchModal
            close={this.setNewBatchModalVisibility}
            batchesInfo={this.props.batchesInfo}
            selectedRow={this.state.selectedRow}
            quantityValue={this.state.totalLoaded}
            fetchBatches={this.fetchBatches}
            returnBatch={this.returnBatch.bind(this)}
            keepLoaded={this.keepLoaded}
            oldLoaded={this.state.oldQuantity}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createSerialNumDialogStyle}
          isVisible={this.state.serialNumOpen}
          onCloseClicked={() => { this.closeSerialNum() }}
          title={<Translate value="set_products_serial_num" />}>
          <SerialNumModal
            closeC={this.closeSerialNum}
            totalLoaded={ this.state.totalLoaded }
            returnSerialNums={ this.returnSerialNums.bind(this) }
            keepLoaded={this.keepLoaded}
            oldLoaded={this.state.oldQuantity}
            currentSerialNo={currentSerialNo}
            setSerialNums={this.setSerialNums.bind(this)}
            isCheckAble={false}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.confirmActionOpen}
          onCloseClicked={() => {
            this.closeAction()
          }}
          title={<Translate value="confirm_action" />}>
          <ConfirmActionModal
            closeC={this.closeAction}
            case={"quantityZero"}
            caseAction={this.createInvoice.bind(this)}/>
        </SkyLightStateless>
        <EmailContentModal
          visible={this.state.emailContentModalVisibility}
          subject={this.state.emailSubjectTemplate}
          content={this.state.emailContentTemplate}
          onConfirm={this.handleEmailContentConfirm}
          onClose={this.handleEmailContentClose}
          selectedRows={[{Deliver_Customer_id: this.props.currentSalesOrder.Deliver_Customer_id}]}
          source={"SI"}
        />
      </ContentWrapper>
    )
  }
}

export default SalesShippingModal;

function roundTo(n, digits) {
   if (digits === undefined) {
     digits = 0;
   }

   var multiplicator = Math.pow(10, digits);
   n = parseFloat((n * multiplicator).toFixed(11));
   var test =(Math.round(n) / multiplicator);
   return +(test.toFixed(2));
}



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/salesShippingModal.jsx